import Cookies from 'js-cookie';
import * as actionTypes from '../constants/userConstants';



import axios from 'axios';



// export const signUpUser = (phone, email, fullName, password, gender) => async (dispatch) => {
//     try {
//         dispatch({ type: actionTypes.SIGNUP_REQUEST });
//         const response = await axios.post('https://api.utkarsita.com/api/v1/signup', {
//             phone,
//             email,
//             fullName,
//             password,
//             gender
//         });

//         const customToken = response.data.token;

//         signInWithCustomToken(auth, customToken)
//           .then((userCredential) => {
//             // Signed in
//             const user = userCredential.user;
//             // ...
//             dispatch({ type: actionTypes.SAVE_TOKEN_IN_COOKIE, payload: customToken });
//             dispatch({
//                 type: actionTypes.SIGNUP_SUCCESS,
//                 payload: response.data
//             });
//             alert('Signin Successful!');
//           })
//           .catch((error) => {
//             const errorCode = error.code;
//             const errorMessage = error.message;
//             // ...
//             dispatch({
//                 type: actionTypes.SIGNUP_FAIL,
//                 payload: error.response && error.response.data.message ? error.response.data.message : error.message
//             });
//           });
//     } catch (error) {
//         dispatch({
//             type: actionTypes.SIGNUP_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message
//         });
//     }
// };

//Generate OTP
export const generateAndStoreOTP = (phoneNumber) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GENERATE_AND_STORE_OTP_REQUEST });
    const formattedPhoneNumber = `+91${phoneNumber}`;
    const response = await axios.post('/api/v1/sendOtp', { phoneNumber: formattedPhoneNumber });

    dispatch({
      type: actionTypes.GENERATE_AND_STORE_OTP_SUCCESS,
      payload: response.data,
    });

    console.log(response.data);

  } catch (error) {
    dispatch({
      type: actionTypes.GENERATE_AND_STORE_OTP_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const verifyOTP = (phoneNumber, otpString) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.VERIFY_OTP_REQUEST });

    const formattedPhoneNumber = `+91${phoneNumber}`; // Add the country code prefix to the phone number
    console.log('Formatted Phone Number:', formattedPhoneNumber);
    console.log('OTP String:', otpString);

    const response = await axios.post('/api/v1/verifyOTP-login-signup', {
      phoneNumber: formattedPhoneNumber,
      otp: otpString,
    });

    console.log('Backend Response:', response.data);

    const { user, shouldProceedToSignup } = response.data;

    // Store user information in cookies
    if (user) {
      const userData = {
        name: user.name,
        phone: user.phone,
        objectId: user.id,
      };
      Cookies.set('userData', JSON.stringify(userData));
      // Storing in localStorage
      localStorage.setItem('userData', JSON.stringify(userData));
    }

    dispatch({
      type: actionTypes.VERIFY_OTP_SUCCESS,
      payload: { user, shouldProceedToSignup },
    });

    console.log('User ID:', user ? user.id : null);
    console.log('Should Proceed to Signup:', shouldProceedToSignup);

    return response.data; // Return the response from the backend

  } catch (error) {
    console.error('Error during OTP verification:', error.message);
    dispatch({
      type: actionTypes.VERIFY_OTP_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
    throw error; // Throw the error to be caught by the caller
  }
};

export const signUpUser = (phoneNumber, name, dob, gender, email, password) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SIGNUP_REQUEST });
    const formattedPhoneNumber = `+91${phoneNumber}`;
    const response = await axios.post('/api/v1/signup', {
      phone: formattedPhoneNumber,
      fullName: name,
      dob,
      gender,
      email,
      password,
    });

    const { user } = response.data;

    // Store user information in cookies
    const userData = {
      name: user.name,
      phone: user.phone,
      objectId: user.id
    };
    Cookies.set('userData', JSON.stringify(userData));
    localStorage.setItem('userData', JSON.stringify(userData));
    // Call checkAccessToken function after setting access token cookie
    dispatch({
      type: actionTypes.SIGNUP_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.SIGNUP_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
    throw error;
  }
};

//LOGIN USING EMAIL PASSWORD

export const signinWithEmail = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SIGNIN_REQUEST });
    const response = await axios.post('/api/v1/login', {
      email,
      password,
    });

    console.log('Login response:', response.data);

    const { user } = response.data;

    dispatch({
      type: actionTypes.SIGNIN_SUCCESS,
      payload: { user },
    });

    // Set the auTE and uaTfl cookies
    Cookies.set('auTE', response.data.auTE, { expires: 365 * 24 * 60 * 60 });
    Cookies.set('uaTfl', response.data.uaTfl, { expires: 365 * 24 * 60 * 60 });

    console.log('Cookies set:', Cookies.get());

    alert('Login Successful!');
  } catch (error) {
    console.error('Login error:', error);

    dispatch({
      type: actionTypes.SIGNIN_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message
    });
  }
};


//CHECK USER EXISTENCE
export const checkUserExists = (phoneNumber) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.CHECK_USER_EXISTS_REQUEST });

    const response = await axios.post('/api/v1/verify-user', { phoneNumber });

    dispatch({
      type: actionTypes.CHECK_USER_EXISTS_SUCCESS,
      payload: response.data,
    });
    console.log(response.data)

  } catch (error) {
    dispatch({
      type: actionTypes.CHECK_USER_EXISTS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
export const checkEmailExists = (email) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.CHECK_EMAIL_EXISTS_REQUEST });

    const response = await axios.post('/api/v1/verify-email', { email });

    dispatch({
      type: actionTypes.CHECK_EMAIL_EXISTS_SUCCESS,
      payload: response.data,
    });
    console.log(response.data)

  } catch (error) {
    dispatch({
      type: actionTypes.CHECK_EMAIL_EXISTS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

const regenerateAccessToken = async () => {
  try {
    const response = await axios.post('/api/auth/token');
    const { accessToken, expiresIn } = response.data;
    const expireTime = new Date(new Date().getTime() + expiresIn * 1000);

    Cookies.set('_acToken', accessToken, { expires: expireTime });
    Cookies.set('_aTExp', expireTime, { expires: expireTime });

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//CHECK USER AUTH
// export const isLoggedIn = () => {
//   const accessToken = Cookies.get('uaTfl');
//   const authTokenExp = Cookies.get('auTE');
  
//   if (!accessToken) {
//     console.log('Auth token is missing');
//     setIsLoggedIn(false);
//     return { type: actionTypes.CHECK_LOGIN_STATUS, isLoggedIn: false };
//   }

//   if (!authTokenExp) {
//     console.log('Auth token expiration time is missing');
//     setIsLoggedIn(false);
//     return { type: actionTypes.CHECK_LOGIN_STATUS, isLoggedIn: false };
//   }

//   const now = new Date().getTime(); // Get current time in milliseconds
//   const tokenExpireTime = new Date(parseInt(authTokenExp, 10) * 1000); // Convert authTokenExp from seconds to milliseconds

//   if (now > tokenExpireTime) {
//     console.log('Auth token has expired');
//     setIsLoggedIn(false);
//     return { type: actionTypes.CHECK_LOGIN_STATUS, isLoggedIn: false };
//   }

//   console.log('User is logged in');
//   setIsLoggedIn(true);
//   return { type: actionTypes.CHECK_LOGIN_STATUS, isLoggedIn: true };
// };

// export const setIsLoggedIn = (isLoggedIn) => {
//   localStorage.setItem('isLoggedIn', isLoggedIn);
// };


const checkAccessToken = async () => {
  const expireTime = Cookies.get('_aTExp');
  const accessToken = Cookies.get('_acToken');

  if (!expireTime || !accessToken) {
    // If either cookie is missing, the user is not logged in
    return false;
  }

  const currentTime = new Date().getTime() / 1000; // Convert to seconds
  const accessTokenExpTime = parseInt(expireTime, 10);

  const timeUntilExpiry = accessTokenExpTime - currentTime - 5; // Subtract 5 seconds for buffer time

  if (timeUntilExpiry <= 0) {
    // If the access token has expired, regenerate a new one
    const success = await regenerateAccessToken();
    if (!success) {
      return false;
    }
  }

  // Call this function again right before the access token expires again
  setTimeout(checkAccessToken, timeUntilExpiry * 1000);
};

// Call the checkAccessToken function automatically every minute
setInterval(checkAccessToken, 60 * 1000);
//LOGOUT CURRENT DEVICE
export const logoutCurrentUser = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SIGNOUT_REQUEST });

    // Clear the access token cookie to log the user out
    Cookies.remove('auTE');
    Cookies.remove('uaTfl');
    Cookies.remove('userData');

    dispatch({
      type: actionTypes.SIGNOUT_SUCCESS,
    });

    console.log('Logout successful');
    alert('Logout successful');
  } catch (error) {
    dispatch({
      type: actionTypes.SIGNOUT_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

//SIGNOUT FROM ALL DEVICES
export const logoutAllDevices = () => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SIGNOUT_REQUEST });

    // Send a request to the server to delete all refresh tokens for the user
    await axios.delete('/api/v1/logout/all');

    // Clear the access token cookie to log the user out
    Cookies.remove('_acToken');

    dispatch({
      type: actionTypes.SIGNOUT_SUCCESS,
    });

    console.log('Logout successful on all devices');
    alert('Logout successful on all devices');
  } catch (error) {
    dispatch({
      type: actionTypes.SIGNOUT_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};






// export const signInUser = (email, password) => async (dispatch) => {
//     try {
//         dispatch({ type: actionTypes.SIGNIN_REQUEST });
//         const response = await axios.post('https://api.utkarsita.com/api/v1/signin', {
//             email,
//             password,
//         });

//         // Set the token in a variable
//         const token = response.data.token;

//         // Store the token in a cookie
//         dispatch({ type: actionTypes.SAVE_TOKEN_IN_COOKIE, payload: token });

//         dispatch({
//             type: actionTypes.SIGNIN_SUCCESS,
//             payload: response.data
//         });
//         alert('Signin Successful!');
//     } catch (error) {
//         dispatch({
//             type: actionTypes.SIGNIN_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message
//         });
//     }
// };

// //GET USER DETAILS
// export const getUserDetails = () => async (dispatch) => {
//     try {
//         dispatch({ type: actionTypes.GET_CURRENT_USER_REQUEST });

//         const token = document.cookie.split('; ')
//             .find(row => row.startsWith('_lscacstn='))
//             .split('=')[1];
//         const headers = {
//             authorization: token
//         };

//         const response = await axios.get('/api/v1/profile', { headers });

//         dispatch({
//             type: actionTypes.GET_CURRENT_USER_SUCCESS,
//             payload: response.data
//         });
//     } catch (error) {
//         dispatch({
//             type: actionTypes.GET_CURRENT_USER_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message
//         });
//     }
// };


// // export const userLoggedIn = (response) => async (dispatch) => {
// //     dispatch({ type: actionTypes.SIGNIN_REQUEST });
// //     try {
// //         if (response.status === 201) {
// //             dispatch({
// //                 type: actionTypes.SIGNIN_SUCCESS,
// //                 payload: response.data
// //             });
// //         } else {
// //             dispatch({
// //                 type: actionTypes.SIGNIN_FAIL,
// //                 payload: response.data.error,
// //             });
// //         }
// //     } catch (error) {
// //         console.error("Error dispatching signIn action: ", error);
// //     }
// // };

// export const logoutUser = () => async (dispatch) => {
//     dispatch({ type: actionTypes.SIGNOUT_REQUEST });
//     try {
//         auth.signOut();
//         dispatch({
//             type: actionTypes.SIGNOUT_SUCCESS,
//         });
//     } catch (error) {
//         console.error("Error dispatching signOut action: ", error);
//         dispatch({
//             type: actionTypes.SIGNOUT_FAIL,
//             payload: error,
//         });
//     }
// };

// export const checkAuth = () => async (dispatch) => {
//     dispatch({ type: actionTypes.CHECK_AUTH_REQUEST });
//     try {
//         const currentUser = await auth.getCurrentUser();
//         if (currentUser) {
//             dispatch({
//                 type: actionTypes.CHECK_AUTH_SUCCESS,
//                 payload: currentUser,
//             });
//         } else {
//             dispatch({ type: actionTypes.CHECK_AUTH_FAIL });
//         }
//     } catch (error) {
//         console.error('Error checking auth: ', error);
//         dispatch({
//             type: actionTypes.CHECK_AUTH_FAIL,
//             payload: { message: error.message },
//         });
//     }
// };

// export const signOutFromAlldevices = (token) => async (dispatch) => {
//     try {
//         dispatch({ type: actionTypes.SIGNOUT_REQUEST });
//         await axios.post("/api/v1/logout", {}, { headers: { Authorization: `Bearer ${token}` } });

//         dispatch({ type: actionTypes.SIGNOUT_SUCCESS });
//         alert("Sign Out Successful!");
//     } catch (error) {
//         dispatch({
//             type: actionTypes.SIGNOUT_FAIL,
//             payload: error.response && error.response.data.message ? error.response.data.message : error.message
//         });
//     }
// };

// export const signOutFromCurrentDevice = () => async (dispatch) => {
//     try {
//         dispatch({ type: actionTypes.SIGNOUT_REQUEST });
//         await auth.signOut();
//         dispatch({ type: actionTypes.SIGNOUT_SUCCESS });
//         alert("Sign Out Successful!");
//     } catch (error) {
//         dispatch({
//             type: actionTypes.SIGNOUT_FAIL,
//             payload: error.message
//         });
//     }
// };

// //CURENT USER
// export const getCurrentUser = () => {
//     return (dispatch) => {
//         dispatch({ type: actionTypes.GET_CURRENT_USER_REQUEST });
//         const cookie = document.cookie;
//         if (cookie) {
//             const customToken = cookie.split('; ')
//                 .find(row => row.startsWith('_lscacstn='));
//             if (customToken) {
//                 // User is logged in, get the user's data
//                 auth.signInWithCustomToken(customToken)
//                     .then((userCredential) => {
//                         const user = userCredential.user;
//                         dispatch({ type: actionTypes.GET_CURRENT_USER_SUCCESS, payload: user });
//                     })
//                     .catch((error) => {
//                         // Handle error
//                         dispatch({ type: actionTypes.GET_CURRENT_USER_FAIL });
//                     });
//                 return;
//             }
//         }
//         // User is not logged in or cookie is invalid, dispatch fail action
//         dispatch({ type: actionTypes.GET_CURRENT_USER_FAIL });
//     };
// };
export const getCurrentUser = (payload) => {
  return async (dispatch) => {
    try {
      const token = Cookies.get("uaTfl");
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.post(`/api/v1/profile`, {}, headers);
      console.log(res.status);
      dispatch({ type: actionTypes.GET_CURRENT_USER_REQUEST });
      if (res.status === 200) {
        console.log(res.data);
        dispatch({
          type: actionTypes.GET_CURRENT_USER_SUCCESS,
          payload: res.data, // Pass user data directly
        });
      } else {
        const { error } = res.data;
        dispatch({
          type: actionTypes.GET_CURRENT_USER_FAIL,
          payload: { error },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};



